"use strict";
// @ts-ignore
try {
    self['workbox:broadcast-update:6.5.2'] && _();
}
catch (e) { }
